import { createSlice } from "@reduxjs/toolkit";

import { fetchArchivedProposalsByReason } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load archived proposals by reason.";

const archivedProposalsByReasonSlice = createSlice({
  name: "archivedProposalsByReason",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchivedProposalsByReason.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchArchivedProposalsByReason.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchArchivedProposalsByReason.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default archivedProposalsByReasonSlice.reducer;
